<template>
  <the-modal
    v-if="isVisible"
    :closeable="true"
    modal-with="medium"
    @close="closeMe">
    <div class="relative" slot="header">
      <div
        class="rounded-full bg-white shadow p-1 absolute right-0 top-0 -mt-4 -mr-4 cursor-pointer hover:text-main z-10"
        @click="closeMe"
        v-if="true"><action-icons icon="close" /></div>
    </div>
    <div slot="body" class="relative" id="popup-content" v-html="processedContent"></div>
    <div slot="footer"></div>
  </the-modal>
</template>
<script>
export default {
  name: 'popup-component',
  props: {
    popupContent: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      processedContent: '',
      isVisible: false,
    }
  },
  methods: {
    closeMe() {
      this.isVisible = false;
    }
  },
  mounted() {
    if (this.popupContent == null) {
      return;
    }

    this.processedContent = this.popupContent;

    setTimeout(() => {
      this.isVisible = true;

      setTimeout(() => {
        let contentWrapper = document.getElementById('popup-content');
        let iframes  = contentWrapper.querySelectorAll('iframe');

        if (iframes.length > 0) {
          this.processedContent = '<div class="videoWrapper">' + this.popupContent + '</div>';
        }
      }, 150);

    }, 500);
  }
}
</script>